import * as Constants from "../../utils/Constants";
import EndpointsBase from "../EndpointsBase";
import ServerRequestWrapper from "../ServerRequestWrapper";

const server = new ServerRequestWrapper(Constants.API_PATH + "/api/autostorereview/");
class Endpoints extends EndpointsBase {
    getAutoStoreReviewBox(barcode:string, forceTransit:boolean) {
      return this._sendRequest({
        method: 'box/'+barcode+ ((forceTransit)? "/true":"/false"),
        headers: this._getAuthHeader(),
        run: server.get,
        data: {},
      });
    }

    restartDelivery = (invoiceNumber: number) => {
      return this._sendRequest({
        method: "review/restartdelivery",
        headers: this._getAuthHeader(),
        data: { invoiceNumber, restartFull:true },
        run: this.server.getData,
      })
    }

    replaceBox = (sortBoxId: number, newBoxBarcode:string) => {
      return this._sendRequest({
        method: "box/replace/"+sortBoxId,
        headers: this._getAuthHeader(),
        data: {newBoxBarcode},
        run: server.postData,
      })
    }
}

export default new Endpoints();